module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-9d90b727.png";